(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/org-nr-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/org-nr-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const ORGANIZATION_NUMBER = svs.ticket_partner.sharedComponents.input.constants.names.ORGANIZATION_NUMBER;
const validateOrgNumber = svs.ticket_partner.utils.validateOrgNumber;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input.constants.TEXTS.ORGANIZATION_NUMBER,
  LABEL = _svs$ticket_partner$s.LABEL,
  MAX = _svs$ticket_partner$s.MAX,
  MAX_ERROR = _svs$ticket_partner$s.MAX_ERROR,
  REQUIRED_ERROR = _svs$ticket_partner$s.REQUIRED_ERROR,
  MIN_ERROR = _svs$ticket_partner$s.MIN_ERROR,
  MIN = _svs$ticket_partner$s.MIN;
const OrgNrInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    disabled = _ref.disabled,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  return React.createElement(TextInput, {
    disabled: disabled,
    errorMessageMax: MAX_ERROR,
    errorMessageMin: MIN_ERROR,
    errorMessageRequired: REQUIRED_ERROR,
    id: ORGANIZATION_NUMBER,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: LABEL,
    max: MAX,
    min: MIN,
    name: name || ORGANIZATION_NUMBER,
    onChange: handleChange,
    validateFn: validateOrgNumber,
    value: state[ORGANIZATION_NUMBER]
  });
};
svs.ticket_partner.sharedComponents.input.OrgNrInput = OrgNrInput;

 })(window);